(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["gwd-buybox"] && !Shopify.designMode) return;
  try {
    (function () {
  function bind(root) {
    if (!root || root.dataset.gwdBuyboxBound === 'true') return;
    root.dataset.gwdBuyboxBound = 'true';
    var toggle = root.querySelector('[data-gwd-buybox-toggle]');
    var other = root.querySelector('[data-gwd-buybox-other]');
    var field = root.querySelector('[data-gwd-buybox-field]');
    var details = root.querySelector('[data-gwd-buybox-details]');
    var legal = root.querySelector('[data-gwd-buybox-legal]');
    var mq = window.matchMedia('(min-width: 990px)');

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (mq.matches) return;
        var open = !root.classList.contains('is-open');
        root.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    if (other && field) {
      other.addEventListener('click', function () {
        var open = other.getAttribute('aria-expanded') !== 'true';
        other.setAttribute('aria-expanded', open ? 'true' : 'false');
        field.hidden = !open;
        if (open) {
          var input = field.querySelector('[data-gwd-amount]');
          if (input) input.focus();
        }
      });
    }

    root.addEventListener('click', function (event) {
      var chip = event.target.closest('[data-gwd-chip]');
      if (!chip || !root.contains(chip)) return;
      if (other) other.setAttribute('aria-expanded', 'false');
      if (field) field.hidden = true;
    });

    if (details && legal) {
      details.addEventListener('click', function () {
        var open = details.getAttribute('aria-expanded') !== 'true';
        details.setAttribute('aria-expanded', open ? 'true' : 'false');
        legal.hidden = !open;
        root.classList.toggle('is-details', open);
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-gwd-buybox]').forEach(bind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-featured-review"] && !Shopify.designMode) return;
  try {
    (function () {
  function a11y(key, fallback) {
    return window.puString ? window.puString(key, fallback) : fallback;
  }

  var INTERVAL = 6000;
  var IDLE = 4000;
  var MAX_QUOTES = 5;

  function watchMs(card) {
    var n = NaN;
    if (card && card.hasAttribute('data-watch-ms')) n = parseInt(card.getAttribute('data-watch-ms'), 10);
    if (!isFinite(n) || n < 0) {
      var host = document.querySelector('.template-product');
      var raw = host ? window.getComputedStyle(host).getPropertyValue('--fr-watch-ms') : '';
      n = parseInt(raw, 10);
    }
    if (!isFinite(n) || n < 0) return 10000;
    return n;
  }

  function dropReserve(card) {
    if (!card) return;
    card.removeAttribute('data-fr-reserve');
    if (card.hasAttribute('hidden')) {
      var heroSlot = card.closest('[data-hero-quotes]');
      if (heroSlot) heroSlot.removeAttribute('data-fr-reserve');
    }
  }

  var existing = window.__pdpFeaturedReview;
  if (existing && existing.init) {
    existing.init(document);
    return;
  }

  var slot = window.__pdpFeaturedReview = { pending: [], jobs: [] };

  function onScreen(card) {
    var hidden = card.hasAttribute('hidden');
    if (hidden) card.hidden = false;
    var visible = card.getClientRects().length > 0;
    if (hidden) card.hidden = true;
    return visible;
  }

  /* Two shells, one block. Below 990px the hero copy is the one in view.
     At 990px and up, the section copy is. The other stays display:none. */
  function copyVisible(card) {
    if (!card) return false;
    var copy = card.getAttribute('data-fr-copy') || 'section';
    var phone = window.matchMedia('(max-width: 989px)').matches;
    var paired = document.querySelector('[data-hero-quotes]') && document.querySelector('.product-quotes-band');
    if (phone && paired) return copy === 'hero';
    return copy !== 'hero';
  }

  function syncQuoteCopies() {
    var pending = slot.pending.slice();
    for (var i = 0; i < pending.length; i++) {
      if (!copyVisible(pending[i])) {
        pending[i].dataset.frWatch = '';
        release(pending[i]);
      }
    }
    init(document);
    for (var j = 0; j < slot.jobs.length; j++) {
      var job = slot.jobs[j];
      if (!job.start || !job.stop) continue;
      if (copyVisible(job.card)) job.start();
      else job.stop();
    }
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cards = scope.querySelectorAll('[data-featured-review]');
    if (!cards.length && scope !== document) return;
    for (var c = 0; c < cards.length; c++) prepare(cards[c]);
  }
  slot.init = init;

  function excluded(node) {
    if (!node || !node.closest) return false;
    return !!(node.closest('.jdgm-quest__body') || node.closest('.jdgm-ans__body') || node.closest('.jdgm-legacy-widget-content') || node.closest('.jdgm-ssr-questions'));
  }

  function bodyText(rev) {
    var bodyEl = rev.querySelector('.jdgm-rev__body');
    if (!bodyEl || excluded(bodyEl)) return '';
    if (bodyEl.classList.contains('jdgm-quest__body') || bodyEl.classList.contains('jdgm-ans__body')) return '';
    var clone = bodyEl.cloneNode(true);
    var banned = clone.querySelectorAll('.jdgm-quest__body, .jdgm-ans__body');
    for (var b = banned.length - 1; b >= 0; b--) {
      if (banned[b].parentNode) banned[b].parentNode.removeChild(banned[b]);
    }
    return (clone.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function reviewNodes() {
    var out = [];
    var seen = [];
    function add(rev) {
      if (!rev || seen.indexOf(rev) !== -1 || excluded(rev)) return;
      seen.push(rev);
      out.push(rev);
    }
    function scan(root) {
      if (!root || !root.querySelectorAll || excluded(root)) return;
      var revs = root.querySelectorAll('.jdgm-rev');
      for (var i = 0; i < revs.length; i++) add(revs[i]);
    }
    scan(document.getElementById('judgeme_product_reviews'));
    var lists = document.querySelectorAll('.jdgm-ssr-reviews__list');
    for (var L = 0; L < lists.length; L++) scan(lists[L]);
    return out;
  }

  function collectPool() {
    var pool = [];
    var keys = [];
    var revs = reviewNodes();
    for (var i = 0; i < revs.length; i++) {
      var text = bodyText(revs[i]);
      var rateEl = revs[i].querySelector('.jdgm-rev__rating');
      var score = rateEl && !excluded(rateEl) ? parseInt(rateEl.getAttribute('data-score') || '0', 10) : 0;
      if (score !== 5 || text.length < 40 || text.length > 400) continue;
      var authEl = revs[i].querySelector('.jdgm-rev__author');
      var author = authEl && !excluded(authEl) ? authEl.textContent.replace(/\s+/g, ' ').trim() : '';
      var key = author + '\n' + text;
      if (keys.indexOf(key) !== -1) continue;
      keys.push(key);
      pool.push({ text: text, score: score, author: author });
    }
    return pool;
  }

  function release(card) {
    var next = [];
    for (var i = 0; i < slot.pending.length; i++) {
      if (slot.pending[i] !== card) next.push(slot.pending[i]);
    }
    slot.pending = next;
    if (next.length) return;
    if (slot.observer) slot.observer.disconnect();
    slot.observer = null;
    if (slot.timer) window.clearTimeout(slot.timer);
    slot.timer = 0;
    if (slot.raf) window.cancelAnimationFrame(slot.raf);
    slot.raf = 0;
  }

  function scanPending() {
    slot.raf = 0;
    var pending = slot.pending.slice();
    for (var i = 0; i < pending.length; i++) prepare(pending[i]);
  }

  function finishWatch() {
    var pending = slot.pending.slice();
    if (slot.observer) slot.observer.disconnect();
    slot.observer = null;
    if (slot.timer) window.clearTimeout(slot.timer);
    slot.timer = 0;
    if (slot.raf) window.cancelAnimationFrame(slot.raf);
    slot.raf = 0;
    slot.pending = [];
    for (var i = 0; i < pending.length; i++) {
      pending[i].dataset.frWatch = 'done';
      prepare(pending[i]);
    }
  }

  function watchRoots() {
    var roots = [];
    function covered(node) {
      for (var i = 0; i < roots.length; i++) {
        if (roots[i] === node || (roots[i].contains && roots[i].contains(node))) return true;
      }
      return false;
    }
    function push(node) {
      if (!node || covered(node)) return;
      roots.push(node);
    }
    var sections = document.querySelectorAll('.product-reviews');
    for (var s = 0; s < sections.length; s++) push(sections[s]);
    push(document.getElementById('judgeme_product_reviews'));
    var lists = document.querySelectorAll('.jdgm-ssr-reviews__list');
    for (var L = 0; L < lists.length; L++) {
      if (!lists[L].closest('.jdgm-legacy-widget-content')) push(lists[L]);
    }
    if (!roots.length) push(document.getElementById('MainContent'));
    return roots;
  }

  function ensureWatch(card) {
    var ms = watchMs(card);
    if (ms === 0) {
      card.dataset.frWatch = 'done';
      dropReserve(card);
      return;
    }
    if (slot.pending.indexOf(card) === -1) slot.pending.push(card);
    card.dataset.frWatch = '1';
    if (slot.observer || slot.timer) return;
    var roots = watchRoots();
    var pageWatch = false;
    for (var p = 0; p < roots.length; p++) {
      if (roots[p] && roots[p].id === 'MainContent') pageWatch = true;
    }
    if (window.MutationObserver && roots.length) {
      slot.observer = new MutationObserver(function () {
        if (pageWatch) {
          if (slot.raf) return;
          slot.raf = window.requestAnimationFrame(scanPending);
          return;
        }
        scanPending();
      });
      for (var r = 0; r < roots.length; r++) {
        slot.observer.observe(roots[r], { childList: true, subtree: true, characterData: true });
      }
    }
    slot.timer = window.setTimeout(finishWatch, ms);
  }

  function destroyCard(card) {
    var keep = [];
    for (var i = 0; i < slot.jobs.length; i++) {
      if (slot.jobs[i].card === card) slot.jobs[i].destroy();
      else keep.push(slot.jobs[i]);
    }
    slot.jobs = keep;
    release(card);
  }

  function prepare(card) {
    if (!card || card.dataset.frReady === 'true') return;
    if (!card.isConnected) {
      release(card);
      return;
    }
    if (!copyVisible(card)) return;
    if (!onScreen(card)) {
      if (card.dataset.frWatch !== 'done') ensureWatch(card);
      return;
    }
    var pool = collectPool();
    if (!pool.length) {
      if (card.dataset.frWatch !== 'done') ensureWatch(card);
      if (card.dataset.frWatch === 'done') dropReserve(card);
      return;
    }
    card.dataset.frReady = 'true';
    release(card);
    for (var s = pool.length - 1; s > 0; s--) {
      var swap = Math.floor(Math.random() * (s + 1));
      var heldQuote = pool[s];
      pool[s] = pool[swap];
      pool[swap] = heldQuote;
    }
    if (pool.length > MAX_QUOTES) pool.length = MAX_QUOTES;
    if (pool.length < 2) card.classList.add('pdp-fr--single');

    var track = card.querySelector('[data-fr-track]');
    var dots = card.querySelector('[data-fr-dots]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var index = 0;
    var timer = 0;
    var idleTimer = 0;
    var held = false;
    var buyboxHeld = false;

    for (var n = 0; n < pool.length; n++) {
      var slide = document.createElement('figure');
      slide.className = 'pdp-fr__slide';
      slide.setAttribute('role', 'group');
      slide.setAttribute('aria-roledescription', 'quote');
      slide.setAttribute('aria-label', (n + 1) + a11y('quoteOf', ' of ') + pool.length);
      var stars = document.createElement('div');
      stars.className = 'pdp-fr__stars';
      stars.setAttribute('aria-hidden', 'true');
      stars.textContent = '★★★★★'.slice(0, pool[n].score);
      var quote = document.createElement('blockquote');
      quote.className = 'pdp-fr__quote';
      quote.textContent = '\u201C' + pool[n].text + '\u201D';
      var cite = document.createElement('cite');
      cite.className = 'pdp-fr__author';
      cite.textContent = pool[n].author || card.getAttribute('data-verified-buyer') || 'Verified buyer';
      slide.appendChild(stars);
      slide.appendChild(quote);
      slide.appendChild(cite);
      track.appendChild(slide);
    }

    function pitch() {
      var slide = track.children[0];
      if (!slide) return 0;
      var width = slide.getBoundingClientRect().width;
      if (!width) return 0;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      if (!isFinite(gap)) gap = 0;
      return width + gap;
    }

    function go(next) {
      index = (next + pool.length) % pool.length;
      var step = pitch();
      if (step) track.style.transform = 'translate3d(' + (-index * step) + 'px, 0, 0)';
      var buttons = dots.querySelectorAll('.pdp-fr__dot');
      for (var b = 0; b < buttons.length; b++) {
        if (b === index) buttons[b].setAttribute('aria-current', 'true');
        else buttons[b].removeAttribute('aria-current');
      }
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = 0;
    }

    function start() {
      stop();
      if (reduce || pool.length < 2 || held || buyboxHeld) return;
      timer = window.setInterval(function () { go(index + 1); }, INTERVAL);
    }

    function hold(on) {
      held = on;
      if (on) stop();
      else start();
    }

    if (pool.length > 1) {
      dots.hidden = false;
      for (var d = 0; d < pool.length; d++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pdp-fr__dot';
        dot.setAttribute('aria-label', a11y('showQuote', 'Show quote ') + (d + 1));
        if (d === 0) dot.setAttribute('aria-current', 'true');
        dot.addEventListener('click', (function (pick) {
          return function () {
            go(pick);
            start();
          };
        })(d));
        dots.appendChild(dot);
      }
      card.addEventListener('mouseenter', function () { hold(true); });
      card.addEventListener('mouseleave', function () { hold(false); });
      card.addEventListener('focusin', function () { hold(true); });
      card.addEventListener('focusout', function () { hold(false); });
      var startX = 0;
      card.addEventListener('touchstart', function (event) {
        hold(true);
        startX = event.changedTouches[0].clientX;
      }, { passive: true });
      card.addEventListener('touchend', function (event) {
        var dx = event.changedTouches[0].clientX - startX;
        if (dx > 40) go(index - 1);
        else if (dx < -40) go(index + 1);
        hold(false);
      }, { passive: true });

      var buybox = document.querySelector('[data-buybox]');
      var armIdle = null;
      if (buybox) {
        armIdle = function () {
          buyboxHeld = true;
          stop();
          if (idleTimer) window.clearTimeout(idleTimer);
          idleTimer = window.setTimeout(function () {
            buyboxHeld = false;
            start();
          }, IDLE);
        };
        buybox.addEventListener('pointerdown', armIdle);
        buybox.addEventListener('focusin', armIdle);
        buybox.addEventListener('change', armIdle);
        buybox.addEventListener('input', armIdle);
      }
      start();
      var onResize = function () { go(index); };
      window.addEventListener('resize', onResize);
      slot.jobs.push({
        card: card,
        start: start,
        stop: stop,
        destroy: function () {
          stop();
          if (idleTimer) window.clearTimeout(idleTimer);
          idleTimer = 0;
          window.removeEventListener('resize', onResize);
          if (buybox && armIdle) {
            buybox.removeEventListener('pointerdown', armIdle);
            buybox.removeEventListener('focusin', armIdle);
            buybox.removeEventListener('change', armIdle);
            buybox.removeEventListener('input', armIdle);
          }
        }
      });
    }

    card.hidden = false;
    dropReserve(card);
    go(0);
  }

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target;
    if (!root || !root.querySelectorAll) return;
    var cards = root.querySelectorAll('[data-featured-review]');
    for (var i = 0; i < cards.length; i++) destroyCard(cards[i]);
  });
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    if (!root || !root.querySelector) return;
    if (!root.querySelector('[data-featured-review]') && !root.querySelector('[data-hero-quotes]') && !root.querySelector('.product-quotes-band')) return;
    syncQuoteCopies();
  });
  var placeMq = window.matchMedia('(min-width: 990px)');
  if (placeMq.addEventListener) placeMq.addEventListener('change', function () { syncQuoteCopies(); });

  if (document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function () { init(document); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-grid"] && !Shopify.designMode) return;
  try {
    (function () {
  function prefix() {
    var root = '/';
    if (window.Shopify && Shopify.routes && Shopify.routes.root) root = Shopify.routes.root;
    if (root.slice(-1) !== '/') root += '/';
    return root;
  }

  function handleOf(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return '';
    var href = link.getAttribute('href') || '';
    var match = href.match(/\/products\/([^/?#]+)/);
    if (!match) return '';
    try { return decodeURIComponent(match[1]); } catch (e) { return match[1]; }
  }

  function rank(root) {
    if (root.getAttribute('data-bs-bound') === '1') return;
    var handle = root.getAttribute('data-bs-handle');
    var track = root.querySelector('[data-carousel-track]') || root;
    var limit = parseInt(root.getAttribute('data-bs-limit') || '12', 10);
    if (!handle || !track || !limit) return;
    root.setAttribute('data-bs-bound', '1');
    var url = prefix() + 'collections/' + encodeURIComponent(handle) + '/products.json?sort_by=best-selling&limit=250';
    fetch(url, { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (!data || !data.products || !data.products.length) return;
        var cards = Array.prototype.slice.call(track.querySelectorAll(':scope > .product-card'));
        var byHandle = {};
        cards.forEach(function (card) {
          var h = handleOf(card);
          if (h && !byHandle[h]) byHandle[h] = card;
        });
        var ordered = [];
        var seen = {};
        data.products.forEach(function (product) {
          var card = byHandle[product.handle];
          if (card && !seen[product.handle]) {
            ordered.push(card);
            seen[product.handle] = true;
          }
        });
        if (!ordered.length) return;
        cards.forEach(function (card) {
          if (!seen[handleOf(card)]) ordered.push(card);
        });
        ordered.forEach(function (card, index) {
          var keep = index < limit;
          card.hidden = !keep;
          if (keep) card.removeAttribute('data-bs-extra');
          else card.setAttribute('data-bs-extra', '');
          track.appendChild(card);
        });
        var cap = parseInt(root.getAttribute('data-mobile-cap') || '0', 10);
        if (cap > 0) {
          var shown = 0;
          Array.prototype.forEach.call(track.querySelectorAll(':scope > .product-card'), function (card) {
            if (card.hidden) {
              card.classList.remove('product-card--desktop-only');
              return;
            }
            shown += 1;
            card.classList.toggle('product-card--desktop-only', shown > cap);
          });
        }
        track.dispatchEvent(new Event('scroll'));
      })
      .catch(function () {});
  }

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-bs-handle]').forEach(rank);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
  } catch(e) { console.error(e); }
})();

})();
